// extracted by mini-css-extract-plugin
export default {"container":"newFooter_container__vPNwZ","footer":"newFooter_footer__ysMMz","footer__content":"newFooter_footer__content__WI3lU","footer__below":"newFooter_footer__below__qooS1"};